<template>
<div >
	<Loader :show="loading"></Loader>
	<b-modal id="modalClient" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close">
		<ClientForm :id="id" @loaded="loading=false" @updated="close()" ></ClientForm>
	</b-modal>	
</div>
</template>

<script>
import ClientForm from '@/views/clients/ClientForm'
import Loader from '@/components/Loader'

export default {
	name: 'ClientModal',
	components:{
		ClientForm,
		Loader
	},
	data () {
		return {
			title: 'Crear cliente',
			show: false,
			loading:false,
			id: null
		}
	},
	methods: {
		open (id=null) {
			this.id = id
			if( id!==null ){
				this.loading = true
				this.title = 'Editar cliente'
			}
			this.showModal()
		},
		showModal() {
			this.show = true
			this.$bvModal.show('modalClient')
		},
		close () {
			this.show = false
			this.form = {}
			this.$emit('updated')
			this.$bvModal.hide('modalClient')
		},
	}
}


</script>
